import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { LanguageProvider, ThemeProvider } from "@mmm/ui";
import { LandingScreen } from "./LandingScreen.js";
import "@mmm/ui/styles/reset.css";
import "@mmm/ui/styles/tokens.css";
import "@mmm/ui/styles/layout.css";
import "@mmm/ui/styles/components.css";
import "./styles/landing.css";

// No router and no AuthProvider: the public site is a single page whose only
// way into the product is a link to the app origin (see appOrigin.ts). That is
// what keeps MSAL and react-router out of this bundle.
//
// ThemeProvider is given no persistence adapter, so it remembers the choice in
// the browser — there is no signed-in user here to store it against.
createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ThemeProvider>
      <LanguageProvider>
        <LandingScreen />
      </LanguageProvider>
    </ThemeProvider>
  </StrictMode>
);
